import { Elm } from "./Travel.elm";

Elm.Travel.init({ node: document.getElementById("root") });
